import { Axios } from "../../../../axios";

export function send_answer({ dispatch, commit, rootGetters }, question_slug) {
	Axios.put("/question", {
		app_id: rootGetters.active_application_id,
		q_slug: question_slug,
		value: rootGetters[question_slug + "/answer"]
	})
		.then(function() {
			commit(question_slug + "/set_error_message", "", { root: true });
		})
		.catch(function(error) {
			if (error.response.status === 401) {
				dispatch("logout_user", null, { root: true });
			} else if (error.response.status !== 400) {
				commit(
					question_slug + "/set_error_message",
					"Unable to save your response.",
					{ root: true }
				);
			} else {
				let errors = error.response.data.join(", ");
				commit(question_slug + "/set_error_message", errors, { root: true });
			}
		});
}
